import React from 'react';
import { BellRing, ChevronLeft, ChevronRight } from 'lucide-react';
import { useLang, tx } from '../i18n/LanguageContext';

export const PendingRequestsAlert = ({ count, onOpen }) => {
  const { lang, isRTL } = useLang();
  if (!count) return null;
  const Chev = isRTL ? ChevronLeft : ChevronRight;
  return (
    <button type="button" data-testid="pending-requests-alert" onClick={onOpen}
      className="w-full mb-6 flex items-center gap-3 p-4 rounded-2xl border border-red-200 bg-red-50 text-start hover:bg-red-100 transition-colors">
      <span className="w-10 h-10 rounded-xl bg-red-500 text-white flex items-center justify-center shrink-0"><BellRing className="w-5 h-5" /></span>
      <span className="flex-1 min-w-0">
        <span className="block font-extrabold text-red-800">{tx(lang, `لديك ${count} ${count === 1 ? 'طلب جديد' : 'طلبات جديدة'} بانتظار ردك`, `You have ${count} new request${count === 1 ? '' : 's'} waiting`)}</span>
        <span className="block text-sm text-red-700/80">{tx(lang, 'طلبات حذف حساب أو استرداد من المستخدمين', 'Account deletion or refund requests from users')}</span>
      </span>
      <span className="inline-flex items-center gap-1 text-sm font-bold text-red-700 shrink-0">{tx(lang, 'عرض الطلبات', 'View requests')}<Chev className="w-4 h-4" /></span>
    </button>
  );
};
